import { forwardRef } from 'react';

// Purely presentational — owns no state. ChatWidget.jsx controls open/closed
// state and the iframe lifecycle (src, postMessage handshake); this component
// just renders the shell and forwards the outer div ref up for the
// outside-click detection in ChatWidget.
const ChatWindow = forwardRef(function ChatWindow({ isOpen, onClose, iframeRef }, ref) {
  return (
    <div ref={ref} className={`chat-window ${isOpen ? 'open' : ''}`}>
      <div className="chat-header">
        <h3>Customer Support</h3>
        <button className="chat-close" onClick={onClose} aria-label="Close chat">
          &times;
        </button>
      </div>
      <div className="chat-content">
        <iframe
          ref={iframeRef}
          title="Customer support chat"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
        />
      </div>
    </div>
  );
});

export default ChatWindow;